// Declare Language global window object
declare global {
  interface Window {
    Language: {
      strings: object;
    };
  }
}

/**
 * Truncate Words
 * @param _words The string of words to truncate
 * @param limit The number of words to limit the truncation to
 * @param after A optional string to place at the end of the truncation
 */
export const truncateWords = (words: string, limit: number, after?: string) => {
  if (!words || !limit)
    throw new Error('string-tools.ts: bad arguments for truncateWords(...)');
  let _words = words;

  // Clean words
  _words = _words.trim();

  // Break words by spaces
  let wordsArray = _words.split(' ');

  // Get original words count
  const originalCount = wordsArray.length;

  // Truncate words array
  wordsArray = wordsArray.slice(0, limit);

  // Get the truncated count
  const truncatedCount = wordsArray.length;

  // Only show the after string if the words string was truncated
  const showAfter = after && truncatedCount < originalCount;

  // Put it back together again
  _words = `${wordsArray.join(' ')}${showAfter ? after : ''}`;

  return _words;
};

/**
 *  Handlize
 *    Takes in a string and converts it to a Shopify formatted handle
 *
 * @param {string} input String to handlize
 * @returns {string} Handle
 */
export const handlize = (input: string): string => {
  let str = input.toLowerCase();
  ['"', "'", '\\', '(', ')', '[', ']'].forEach(
    (token) => (str = str.replace(token, ''))
  );

  str = str.replace(/\W+/g, '-');

  while (str.startsWith('-')) str = str.slice(1);
  while (str.endsWith('-')) str = str.slice(0, -1);

  return str;
};

/**
 *  Liquid
 *    Takes in a string containing liquid-like variables e.g. {{ test }} and
 *    replaces them with the variables provided
 *
 * @param {string} str The liquid string
 * @param {object} vars The variables to replace
 * @returns {string} The formatted string
 */
export const liquid = (str: string, vars: { [key: string]: string } = {}) => {
  const keys = Object.keys(vars);
  const keysLower = keys.map((ey) => ey.toLowerCase());

  return str.replace(/({)?{{[^{}]*}}(?!})/g, function ($0, $1) {
    let x = $0.replace(/[{|\s|}]/g, '');
    if (!x) return $0;

    // Lowercaseify
    x = x.toLowerCase();

    const keyIndex = keysLower.findIndex((key) => key === x);
    if (keyIndex === -1) return $0;
    return vars[keys[keyIndex]];
  });
};

export const t = (key: string, variables: { [key: string]: string } = {}) => {
  let str: string;

  // Try find
  if (window && window.Language && window.Language.strings) {
    str = window.Language.strings[key];
  }
  if (!str || !str.length) return `translation missing: ${key}`;
  return liquid(str, variables);
};
